import React from 'react';
import { PropTypes } from 'prop-types';
import InputMask from 'react-input-mask';
import InputFieldBaseHOC from './InputFieldBase';

import './PhoneNumberInput.scss'
import './TextFormInputField.scss'

const PhoneNumberInput = ({ propertyName, value, lang, onChange, onBlur, autoComplete }) => {
    var isFrenchLanguage = lang.toLowerCase() === 'fr';
    const placeholderText = isFrenchLanguage ? "NNN NNN-NNNN" : "(NNN) NNN NNNN";
    const mask = isFrenchLanguage ? "999 999-9999" : "(999) 999 9999"

    const handleTextChange = (ev) => {
        onChange(propertyName, ev.target.value);
    }

    return (
        <InputMask value={value} name={propertyName}
            className='hrb-province-input' style={{ height: 40 }} autoComplete={autoComplete ? autoComplete : "off"}
            placeholder={placeholderText} mask={mask} maskChar=""
            onChange={(ev) => { handleTextChange(ev) }} onBlur={() => onBlur(propertyName)} />
    )
};

PhoneNumberInput.propTypes = {
    propertyName: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    subtextKey: PropTypes.string,
    errorKey: PropTypes.string,
    autoComplete: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired
};


export default InputFieldBaseHOC(PhoneNumberInput);
